module.exports = __webpack_public_path__ + "img/payment-mastercard.5b08b391.svg";